import React, { Component } from 'react'
import { connect } from 'react-redux'
import { compose } from 'redux'
import { withRouter } from "react-router-dom"
//import { NavLink} from "react-router-dom";
import axios from 'axios'
import { connectNode } from '../../../../utils/global'
import { escapeHtml } from '../../../../utils/textFunctions'
import '../../../../styles/assets/css/admin/list1.css'
import { loadLocationWithMessage } from '../../../../actions/location'

import WarningIcon from '@material-ui/icons/Warning'

import AppBar from '@material-ui/core/AppBar'
import Tab from '@material-ui/core/Tab'
import TabContext from '@material-ui/lab/TabContext'
import TabList from '@material-ui/lab/TabList'
import TabPanel from '@material-ui/lab/TabPanel'

import PatientApptList from "./patient_appt_list"
import ContactLogs from "../contact_logs/contact_logs_list"
import AssignTeam from "./assign_team"
import TreatmentPlanList from "./treatment_plan/treatment_plan_list"
//import ToDoList from "./to_do_list/to_do_list"
import PatientContractList from "../patient_contract/patient_contract_list"
import DischargeForm from "./discharge/discharge_form"

class TabPatient extends Component {
  constructor() {
      super();
      this.state = {
          status: false,
          message: '',
          tab_status: '1',
          uid: 0,
          pid: 0,
          doctor: 0,
          type: 0,
          date: '',
          time: '',
          duration: 0,
          patient_status: 0,
      }
  }

  componentDidMount() {
    //console.log('=> '+this.props.match.params.secondtab)
    if(this.props.match.params.secondtab > 0) {
      this.setState({
        tab_status: this.props.match.params.secondtab,
      })
    }
  }

  handleTabChange = (event, newValue) => {
    this.setState({
      tab_status: newValue,
    })
  }

  handleSubmit = (e) => {
    e.preventDefault()
    axios({
      method: 'post',
      url: connectNode + 'admin/register_patient/add_new_patient',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json;charset=UTF-8'
      },
      data: this.state
    })
    .then((result) => {
        //console.log('Callback: '+result['data'])
        if(result['data'] > 0) {
          //this.props.onLoadPages(response)
          this.props.onLoadLocation('patient_list', 'Adding new patient completed!')
          this.props.history.push('/admin/patient_list')
          /*this.setState({
            message: 'Adding new patient completed!'
          })*/
        } else if(result['data'] === -1) {
          this.setState({
            message: 'This email already exist.'
          })
        } else if(result['data'] === -2) {
          this.setState({
            message: 'Adding new patient completed but system couldn\'t send email reminder!'
          })
        } else {
          this.setState({
            message: 'Something went wrong. Please try again.'
          })
        }
      }
    )
  }

  render() {

    return (
      <div className="">
        <div className="row">
          <div className="small-12 columns tab_data1 tab_patient">
            <TabContext value={this.state.tab_status}>
              <AppBar position="static">
                <TabList onChange={this.handleTabChange} aria-label="simple tabs example">
                  <Tab label="Appointments" value="1" />
                  <Tab label="Contact Logs" value="2" />
                  <Tab label="Clinician/Student/PN" value="3" />
                  <Tab label="Treatment Plan" value="4" />
                  <Tab label="Patient Contract" value="5" />
                  <Tab label="Discharge" value="6" />
                </TabList>
              </AppBar>
              <TabPanel value="1" index={1} ><PatientApptList /></TabPanel>
              <TabPanel value="2" index={2} ><ContactLogs /></TabPanel>
              <TabPanel value="3" index={3} ><AssignTeam /></TabPanel>
              <TabPanel value="4" index={4} ><TreatmentPlanList /></TabPanel>
              <TabPanel value="5" index={5} ><PatientContractList /></TabPanel>
              <TabPanel value="6" index={6} ><DischargeForm /></TabPanel>
            </TabContext>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  //console.log('AddPatient STATE: ', state)
  return state
}

const mapDispatchToProps = (dispatch) => ({
  onLoadPages(response) {
    //console.log('AddPatient mapDispatchToProps')
    dispatch({
      type: 'LOAD_USER_AUTH',
      payload: response,
    })
  },
  onLoadLocation(route, msg) {
    dispatch(loadLocationWithMessage(route, msg))
  },
})

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(TabPatient)
